// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"e8762c48","175":"99c50d75","228":"03d5ce22","304":"98644f0f","369":"b2716f65","448":"e6cec0a9","541":"76b21b89","623":"8a44ca02","672":"45fcfe83","890":"1d118924","981":"287eb365"}[chunkId] + ".chunk.js";
};